import './profile.css';

import LoadingLogo from '../../../../components/loadingLogo/loadingLogo';

export default function Profile() {
    return(
        <div className="no-access">
                <LoadingLogo/>
                <p style={{ color: 'red' }}>Feature not ready yet but will be coming Soon!</p>
              </div>
    )
}